/* unplugin-vue-components disabled */import { render } from "./AiStandardPage.vue?vue&type=template&id=7302bcea&scoped=true"
import script from "./AiStandardPage.vue?vue&type=script&lang=js"
export * from "./AiStandardPage.vue?vue&type=script&lang=js"

import "./AiStandardPage.vue?vue&type=style&index=0&id=7302bcea&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7302bcea"]])

export default __exports__